/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeBreakpointContext, BaSeButton, BaSeSmall2 } from '@base/react';
import React from 'react';
import { ContainerText, DetailContent } from './characteristics-entrepreneur-style';

function Detail({ description }) {
  const { onMobileSmall, onMobile, onMobileLarge } = React.useContext(
    BaSeBreakpointContext,
  );
  const isMobile = onMobile || onMobileSmall || onMobileLarge;

  const [open, setOpen] = React.useState(true);
  const TEXT = <BaSeSmall2 color="#636363">{description}</BaSeSmall2>;

  return (
    <DetailContent>
      {!isMobile ? (
        <div style={{ maxWidth: '240px', marginLeft: 'auto' }}>{TEXT}</div>
      ) : (
        <BaSeButton
          buttonType="button"
          color="default"
          loadingText="Carregando…"
          onClick={() => setOpen((prev) => !prev)}
          rightIcon={
            open ? 'system/arrow-down-s-line' : 'system/arrow-up-s-line'
          }
          size="small"
          type="tertiary"
          value={open ? 'Fechar' : 'Saiba mais'}
        />
      )}

      {open && isMobile && <ContainerText>{TEXT}</ContainerText>}
    </DetailContent>
  );
}

export default Detail;
